import React, { useState } from 'react'
import { Image, Popover, Tag } from 'antd'
import { ApiRequest } from '../../../../services/api/api'
import getImage from '../../common-form/common-image'
import { nbsStr } from '../../../../services/lib/utils/helpers'
import { Card } from 'antd';
import { LoadingOutlined } from '@ant-design/icons'
import moment from 'moment'
import './i-tip-product.css'
import { getCookie } from 'react-use-cookie'

const { Meta } = Card;

interface Iprops{
    id:number,
    label:string,
    isNotCutting?: boolean,
    // Multi-line label mode: split the label into lines (word-boundary safe)
    isWrap?: boolean,
    // Chars per line when isWrap is on (default 35)
    wrapLength?: number,
    baseProductId?:number,
    showSupplierData?: boolean
}

const ItipsForProduct: React.FC<Iprops> = (props) => {
  const [visible, setVisible] = useState(false)
  const [getData, setGetData] = useState<any>({})
  const [stockData, setStockData] = useState<any>(null)
  const [orderData, setOrderData] = useState<any>(null)
  const [workOrderData, setWorkOrderData] = useState<any>([])
  const [purchaseOrder, setPurchaseOrder] = useState<any>([])
  const [supplierData, setSupplierData] = useState<any>([])
  const [employeeData, setEmployeeData] = useState<any>(null)  // 新增：存储 employee 数据
  const showSupplierData = (props.showSupplierData ?? true) && !getCookie('customerUserId')

  // Split the label into lines of up to wrapLength chars, breaking only at spaces (never mid-word)
  const wrapLabelLines = (): string[] => {
    const raw = props.wrapLength ?? 35
    const maxLen = raw > 0 && !Number.isNaN(raw) ? raw : 35
    const words = (props.label || '').split(/\s+/).filter(Boolean)
    const lines: string[] = []
    let current = ''

    for (const word of words) {
      if (!current) {
        current = word
      } else if (current.length + 1 + word.length <= maxLen) {
        current += ' ' + word
      } else {
        lines.push(current)
        current = word
      }
    }
    if (current) lines.push(current)
    return lines
  }
    // const [productId, setProductId] = useState<any>([]) 
  const handleVisibleChange = async (visible: boolean) => {
    let productId;
    if (props.baseProductId){
      await ApiRequest({
        url: 'Product/GetProductByBaseProduct?id=' + props.baseProductId,
        method: 'get',
        isShowSpinner: false
      }).then(res => {
        if (res.data.data[0].productId && res.data.data[0].manufactured == 1){
          // setProductId(res.data.data.productId)
          productId = res.data.data[0].productId
        }
        else{
          setVisible(false)
        }
          
      }).catch(reason => {
        // setGetData({productName: 'Inactive product'})
        setVisible(false)
        return        
      })
    }
    if (!productId && !props.id) return;
    if (!productId) productId =props.id;

    setVisible(visible)
    productId && ApiRequest({
      url: 'Product/GetProductByIdIncludeInactive?id=' + productId,
      method: 'get',
      isShowSpinner: false
    }).then(res => {
      const productData = res.data.data
      setGetData(productData)

      // 如果 customer 有 employee_id，获取 employee 详情
      if (productData?.customer?.employeeId) {
        ApiRequest({
          url: `Employee/GetEmployeeById?id=${productData.customer.employeeId}`,
          method: 'get',
          isShowSpinner: false
        }).then(empRes => {
          setEmployeeData(empRes.data.data)
        }).catch(reason => {
          console.log('Failed to fetch employee data:', reason)
          setEmployeeData(null)
        })
      } else {
        setEmployeeData(null)
      }

    }).catch(reason => {
      setGetData({productName: 'Inactive product'})
    })
    productId && ApiRequest({
      url: 'StockMonitor/GetStockInfoByProductId?productId=' + productId,
      method: 'get',
      isShowSpinner: false
    }).then(res => {
      setStockData(res.data.data)

    }).catch(reason => {
      // setStockData({productName: 'Inactive product'})
    })    
    productId && ApiRequest({
      url: 'Product/GetRecentOrderByProd?id=' + productId,
      method: 'get',
      isShowSpinner: false
    }).then(res => {
      setOrderData(res.data.data)

    }).catch(reason => {
      // setStockData({productName: 'Inactive product'})
    }) 
    productId && ApiRequest({
      url: 'WorkOrder/GetWorkOrderyProductId?productId=' + productId,
      method: 'get',
      isShowSpinner: false
    }).then(res => {
      setWorkOrderData(res.data.data)
    }).catch(reason => {
      // setStockData({productName: 'Inactive product'})
    })        
    productId && ApiRequest({
      url: 'StockMonitor/GetPoQtyByProductId?productId=' + productId,
      method: 'get',
      isShowSpinner: false
    }).then(res => {
      setPurchaseOrder(res.data.data)
    }).catch(reason => {
      // setStockData({productName: 'Inactive product'})
    })             
    if (showSupplierData) {
      productId && ApiRequest({
        url: 'Supplier/GetSupplierForProduct?productId=' + productId,
        method: 'get',
        isShowSpinner: false
      }).then(res => {
        setSupplierData(res.data.data)
      }).catch(reason => {
        // setSupplierData([])
      })
    } else {
      setSupplierData([])
    }
  }

  const renderWorkOrderRow = (item: any, index: number) => {
    const status = item.workOrderStatus?.workOrderStatusName;
    const action = item.actionDto?.actionName;
    const statusLabel = status === 'Progressing' || status === 'Approved'
      ? action
      : status;

    return getRowRender(
      `Work Order ${index + 1}`,
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <span><strong>QTY:</strong> {item.quantity}</span>
        {statusLabel && (
          <Tag color={statusLabel === 'Packaging' ? 'orange' : 'green'}>
            {statusLabel}
          </Tag>
        )}
      </div>
    );
  };


    const getRowRender = (name: any, rowData: any) => (
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {/* 左侧 label 不换行 */}
        <div style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
          {name && <strong>{name}:&nbsp;&nbsp;</strong>}
        </div>
        {/* 右侧内容可换行 */}
        <div style={{ flex: 1 }}>
          {stockData ? (
            <span style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
              {rowData}
            </span>
          ) : (
            <LoadingOutlined />
          )}
        </div>
      </div>
    );


  const content = (
    <Card title={getData?.productCode || 'Product'} bordered={true} style={{ width: 650 }}
    >
      
    <div style={{minWidth: '530px'}}>
      {getImage(getData?.images)}
      {getRowRender('FullName', getData?.productName)}
      {getData?.customer && getRowRender('Customer', getData.customer.customerCode)}
      {getData?.customer && employeeData && getRowRender('Sales', `${employeeData.firstName} ${employeeData.lastName}`)}
      <hr></hr>
      {getRowRender('Units Per Pack/Box', getData?.baseProduct?.packagingType?.packagingTypeName)}
      {getData?.palletStacking && getRowRender(
        'Pallet Stacking',
        <span>
          {getData?.palletStacking?.palletStackingName || getData?.palletStacking}
          {getData?.palletStacking && (
            <span style={{ marginLeft: '8px', fontSize: '13px', color: '#666' }}>
              ({getData.palletStacking.ctnsPerLevel || 0} × {getData.palletStacking.level || 0}
              {getData.palletStacking.addOnQty > 0 ? ` + ${getData.palletStacking.addOnQty}` : ''})
            </span>
          )}
        </span>
      )}
      {getRowRender('In Stock', stockData?.productInventoryInfo ? `${stockData.productInventoryInfo.productInStock}（${stockData.productInventoryInfo.productInStockCartons} Ctns )` : null)}
      {workOrderData.length > 0 && <hr />}
      {getRowRender('Approved Work Order', stockData?.productInventoryInfo ? `${stockData.productInventoryInfo.pendingWorkOrderQuantity}（${stockData.productInventoryInfo.pendingWorkOrderQuantityCartons} Ctns )` : null)}
      <div>
        {workOrderData.map((item: any, index: number) => (
          <div key={item.workOrderId}>
            {renderWorkOrderRow(item, index)}
        </div>
      ))}

        </div> 
      {workOrderData.length > 0 && <hr />}   
      {getRowRender('In Packaging', stockData?.productInventoryInfo ? `${stockData.productInventoryInfo.pendingWarehouseQuantity}（${stockData.productInventoryInfo.pendingWarehouseQuantityCartons} Ctns )` : null)}
      {getRowRender('Customer Order', stockData?.productInventoryInfo ? `${stockData.productInventoryInfo.pendingOrderQuantity}（${stockData.productInventoryInfo.pendingOrderQuantityCartons} Ctns )` : null)}
      {/* {getRowRender('Description', getData?.description)} */}
      {/* {getRowRender('MinOrderQty', getData?.minOrderQuantity)}
      {getRowRender('MarginOfError', getData?.marginOfError)}
      {getRowRender('SemiMsl', getData?.semiMsl)} */}
      {getRowRender('Msl', stockData?.productInventoryInfo ? `${stockData.productInventoryInfo.productMsl}（${stockData.productInventoryInfo.productMslCartons} Ctns )` : null)} 
      <hr></hr>
      {getRowRender('Latest Order',orderData?.recentDate?moment.utc(orderData?.recentDate).local().format('DD/MM/YYYY'):"None")}      
      {getRowRender('Last 6 months Sold', orderData?.recentOrderQty)} 
      {purchaseOrder?.length > 0 && <hr />}   
      {purchaseOrder?.length > 0 && getRowRender('Purchase Details', "")}         
      <div>
          {purchaseOrder?.map((item: any, index: number) => (
            <div key={item.workOrderId} >
              {getRowRender(
                `${item.poNo}`,
                item.quantity+(item.eta ? " (ETA: " + moment(item.eta).format('DD/MM/YYYY') + ")" : "")+(item.notes ? " (Notes: " + item.notes + ")" : "")
              )}
            </div>
          ))}
        </div>   
      {showSupplierData && supplierData?.length > 0 && <hr />}   
      {showSupplierData && (
        <div>
          {getRowRender(
            'Suppliers',
            supplierData?.length ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                {supplierData.map((item: any, index: number) => (
                  <Tag key={index} color="blue">
                    {item.suplierName}
                  </Tag>
                ))}
              </div>
            ) : (
              '-'
            )
          )}
        </div>
      )}

    </div>
    </Card>
  )

  return (
    <Popover
      content={content}
      placement="left"
      // title={<h4 style={{textAlign: 'center'}}>{getData?.productCode || 'Product'}</h4>}
      trigger="hover"
      open={visible}
      onOpenChange={handleVisibleChange}
      overlayStyle={{ zIndex: 9999 }}
    >
      {props.isWrap
        ? wrapLabelLines().map((line, index) => <div key={index} style={{ whiteSpace: 'nowrap' }}>{line}</div>)
        : nbsStr(props.label, props.isNotCutting)}
    </Popover>
  )
}

export default ItipsForProduct
